/*
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-10 15:17:15
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-27 19:05:05
 */
import axios from 'axios'
// eslint-disable-next-line no-unused-vars
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  withCredentials: true, // 跨域请求时发送 cookies
  timeout: 300000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log('store.getters.token',store.getters.token)
    // Do something before request is sent
    if (store.getters.token) {
      // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
      config.headers['Authorization'] = getToken()
    }
    config.headers['Authorization'] = getToken()
    config.params = {
      ...config.params,
      language: store.getters.language
    }
    return config
  },
  error => {
    // Do something with request error
    // console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data
    console.log(res)
    // console.log('api res', res)
    // eslint-disable-next-line eqeqeq
    if (res.code != 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return res
      //   if(res.code == 401){
      // 	store.dispatch('user/resetToken').then(() => {
      // 		location.reload() // 为了重新实例化vue-router对象 避免bug
      // 	  })
      //   }
      //   return Promise.reject('error')
    } else {
      return res
    }

    // if (res.code !== 20000) {
    //   Message({
    //     message: res.message,
    //     type: 'error',
    //     duration: 5 * 1000
    //   })
    //   // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     // 请自行在引入 MessageBox
    //     // import { Message, MessageBox } from 'element-ui'
    //     store.dispatch('user/resetToken').then(() => {
    //       location.reload() // 为了重新实例化vue-router对象 避免bug
    //     })
    //     // MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
    //     //   confirmButtonText: '重新登录',
    //     //   cancelButtonText: '取消',
    //     //   type: 'warning'
    //     // }).then(() => {
    //     //   store.dispatch('user/resetToken').then(() => {
    //     //     location.reload() // 为了重新实例化vue-router对象 避免bug
    //     //   })
    //     // })
    //   }
    //   return Promise.reject('error')
    // } else {
    //   return res
    // }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
